import { render, staticRenderFns } from "./HistoricNfe.vue?vue&type=template&id=2f5618e8&"
import script from "./HistoricNfe.vue?vue&type=script&lang=js&"
export * from "./HistoricNfe.vue?vue&type=script&lang=js&"
import style0 from "./HistoricNfe.vue?vue&type=style&index=0&id=2f5618e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports